import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IUserTruckImplement {
  id?: number;
  startDate?: string | null;
  endDate?: string | null;
  activated?: boolean | null;
  user?: IUser | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IUserTruckImplement> = {};
